import React from 'react';
import * as Yup from 'yup';
import { Link } from '@menuzen/icon/build/outline';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Button, Box, InputAdornment } from '@mui/material';

import FormContainer from '../form/FormContainer';
import TextFieldElement from '../form/TextFormField';
import { labelCss } from '../../style';
import { LoadingButton } from '@mui/lab';
import { CustomLinkValues } from '../../../basic/custom-link/EditCustomLink';

interface AddCustomLinkProps {
    onCancel: () => void;
    onSubmitCustomLink: (oder: CustomLinkValues) => void;
}

const customLinkSchema = Yup.object().shape({
    link: Yup.string().required('URL is required.'),
    text: Yup.string().max(50, 'Text may not be greater than 50 characters.'),
});

const AddCustomLinkForm: React.FC<AddCustomLinkProps> = ({ onSubmitCustomLink, onCancel }) => {
    const defaultValues = {
        text: '',
        link: '',
    };

    const methods = useForm({
        mode: 'onChange',
        reValidateMode: 'onBlur',
        resolver: yupResolver(customLinkSchema),
        defaultValues,
    });

    return (
        <FormContainer formContext={methods} onSubmit={onSubmitCustomLink}>
            <Box>
                <Box mb={2.5}>
                    <Box mb={1} sx={{ ...labelCss() }}>
                        Enter URL
                    </Box>

                    <TextFieldElement
                        id="link"
                        name="link"
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" sx={{ fontSize: 18 }}>
                                    <Link />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                <Box>
                    <Box mb={1} sx={{ ...labelCss() }}>
                        Custom Button Text
                    </Box>
                    <TextFieldElement placeholder={`Visit Our Website`} id="text" name="text" fullWidth />
                </Box>

                <Box display="flex" justifyContent="center" sx={{ mt: '30px', mx: '-5px' }}>
                    <Box sx={{ px: '5px', flex: 1 }}>
                        <Button variant={`outlined`} fullWidth={true} onClick={onCancel}>
                            {`Cancel`}
                        </Button>
                    </Box>
                    <Box sx={{ px: '5px', flex: 1 }}>
                        <LoadingButton variant="contained" color={`primary`} fullWidth={true} type="submit">
                            Done
                        </LoadingButton>
                    </Box>
                </Box>
            </Box>
        </FormContainer>
    );
};

export default AddCustomLinkForm;
